import React from 'react'
import { Page } from '@shopify/polaris'
import ExportTracking from './ExportTracking'
import { Tooltip } from 'antd'
import {InfoCircleOutlined} from "@ant-design/icons";

const ExportTrackingContainer = props => {
    return (
        <Page fullWidth title="Export Tracking" titleMetadata={
            <Tooltip title="User Guide">
                <a href='https://confluence.mymerchize.com/pages/viewpage.action?pageId=114434069' target='_blank'>
                    <InfoCircleOutlined style={{ fontSize: "24px", color: "#1890ff" }}/>
                </a>
            </Tooltip>
        }>
            <ExportTracking {...props} />
        </Page>
    )
}

export default ExportTrackingContainer
